import { Component, OnDestroy, OnInit } from '@angular/core';
import { ValidatorService } from '../../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MessageService } from 'primeng/api';
import { Utils } from '../../../utils';

@Component({
    selector: 'app-validators-options',
    templateUrl: './options.component.html',
    styleUrls: ['./options.component.css']
})

export class ValidatorsOptionsComponent implements OnInit {

    id: number;
    feature: any;
    featureParams = [];
    features = [];
    checkedFeatures = [];
    currentValidator: any = {};
    oldParams = {};
    displayDlg = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private validatorService: ValidatorService,
        private messageService: MessageService,
        private utils: Utils
    ) { }

    ngOnInit() {
        console.log('onInit');
        this.currentValidator = JSON.parse(localStorage.getItem('currentValidatorProvider'));
        console.log(this.currentValidator);
        this.checkedFeatures = this.currentValidator.features.map(feature => feature.id);
        this.validatorService.getAllFeatures()
            .subscribe(
                features => {
                    this.features = features;
                    console.log(this.features);
                },
                error => console.error(error)
            );
    }

    selectOption(feature: any): void {
        this.feature = feature;
        this.oldParams = this.currentValidator.featureParametersMap;
        this.feature.featureParameters.forEach(fp => {
            if (!this.currentValidator.featureParametersMap[fp.id]) {
                this.currentValidator.featureParametersMap[fp.id] = { id: { idValidationProvider: this.currentValidator.id, idFeatureParameter: fp.id }, value: '' };
            }
        });
        this.displayDlg = true;
    }

    save(): void {
        let checkedFeatures = this.features.filter(feature => this.checkedFeatures.includes(feature.id));
        let data = {
            idValidationProvider: this.currentValidator.id,
            features: []
        }
        checkedFeatures.forEach(feature => {
            let idx = data.features.length;
            data.features[idx] = {
                idFeature: feature.id,
                params: feature.featureParameters.map(p => {
                    return { idFeatureParam: p.id, value: this.currentValidator.featureParametersMap[p.id].value }
                })
            };
        });
        console.log('data', data);
        this.validatorService.saveValidatorOption(data)
            .subscribe(
                response => {
                    this.currentValidator.featuresMap = {};
                    this.currentValidator.features = [];
                    this.features.forEach(feature => {
                        this.currentValidator.featuresMap[feature.id] = feature;
                        this.currentValidator.features.push(feature);
                    });
                    localStorage.setItem('currentValidatorProvider', JSON.stringify(this.currentValidator));
                    this.messageService.add({ severity: 'success', summary: 'Zapisano ustawienia opcji' });
                },
                error => {
                    console.error(error);
                    this.messageService.add({ severity: 'success', summary: 'Wystąpił błąd podczas zapisywania opcji', detail: this.utils.handleError(error) });
                }
            );
    }

    reset() {
        this.currentValidator.featureParametersMap = this.oldParams;
        this.oldParams = {};
        this.displayDlg = false;
    }
}

